// src/features/LabelMapping/columns.ts

import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import type { LabelMappingFlatten } from '../../api/label-mapping';
import { ContextButton } from './components/ContextButton';

export const getColumnDefs = (
  showAction: boolean,
): ColDef<Partial<LabelMappingFlatten>>[] => {
  const columns: ColDef<Partial<LabelMappingFlatten>>[] = [
    {
      field: 'parent_path',
      headerName: 'Parent Path',
      width: 300,
      sortable: false,
      sort: 'asc',
      cellRenderer: (p: ICellRendererParams<Partial<LabelMappingFlatten>>) => {
        return <span>{p.data?.parent_path}</span>;
      },
    },
    {
      field: 'name',
      headerName: 'Label Name (WMG1)',
      flex: 1,
      sortable: false,
      sort: 'asc',
      cellRenderer: (p: ICellRendererParams<Partial<LabelMappingFlatten>>) => {
        return <span>{p.data?.name}</span>;
      },
    },
    {
      field: 'mapped_labels',
      headerName: 'Mapped Label(s)',
      flex: 1,
      sortable: false,
      cellRenderer: (p: ICellRendererParams<Partial<LabelMappingFlatten>>) => {
        return (
          p.data?.mapped_labels
            ?.map((l: { mapped_label: string }) => l.mapped_label)
            .join(', ') || <span className="text-subtle">{t('n/a')}</span>
        );
      },
    },
  ];

  if (showAction) {
    columns.push({
      headerName: 'Actions',
      width: 100,
      sortable: false,
      cellRenderer: (p: ICellRendererParams<Partial<LabelMappingFlatten>>) => {
        if (!p?.data?.label_id) {
          return null;
        }

        return <ContextButton label={p.data as LabelMappingFlatten} />;
      },
    });
  }

  return columns;
};
